<template>
  <div>
    <HeaderBreadcrumbs
      :items="[
        { label: 'Announcements', to: { name: 'announcement' } },
      ]"
      title="All Announcements"
    />
    <div class="bg-white my-3 shadow-md rounded-lg">
      <div class="flex justify-end">
        <div class="my-4">
          <router-link class="border bg-blue-700 mr-4 px-4 py-2.5 text-white hover:no-underline rounded-lg" :to="{name: AnnouncementCreatePath.name}">
            + Add New
          </router-link>
        </div>
      </div>
      <t-table class="bg-white shadow-none"
        :data="sortedItems">
        <template v-slot:thead="props">
          <thead class="sticky-header">
            <tr>
              <th :class="props.thClass" class="text-left">Title</th>
              <th :class="props.thClass">Message</th>
              <th :class="props.thClass">
                <div class="flex items-center cursor-pointer" @click="sortBy('valid_from')">
                  Start - END Date
                  <span href="#">
                    <svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </span>
                </div>
              </th>
              <th :class="props.thClass">
                <div class="flex items-center cursor-pointer" @click="sortBy('is_active')">
                  Status
                  <span href="#">
                    <svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </span>
                </div>
              </th>
              <th :class="props.thClass"></th>
            </tr>
          </thead>
        </template>
        <template v-if="isLoading" v-slot:tbody="props">
          <tbody :class="props.tbodyClass">
            <tr :class="[props.trClass, 'text-center']">
              <td :class="props.tdClass" colspan="15">
                <div role="status" class="flex justify-center items-center h-72">
                  <svg aria-hidden="true"
                    class="w-8 h-8 text-gray-200 text-center animate-spin dark:text-gray-600 fill-blue-600"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor" />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill" />
                  </svg>
                  <span class="sr-only text-center items-center">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-else-if="!items.length" v-slot:tbody="props">
          <tbody :class="props.tbodyClass">
            <tr :class="[props.trClass, 'text-center']">
              <td :class="props.tdClass" colspan="15">
                <div class="flex-col items-center justify-center flex-nowrap flex h-96">
                  <svg width="35" height="35" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M36.014 19.1452L29.5936 25.5656L36.014 31.986C36.524 32.5141 36.8063 33.2214 36.7999 33.9555C36.7935 34.6897 36.499 35.3919 35.9799 35.9111C35.4608 36.4302 34.7585 36.7247 34.0243 36.7311C33.2902 36.7375 32.5829 36.4552 32.0548 35.9452L25.6344 29.5248L19.214 35.9452C18.9557 36.2126 18.6467 36.4259 18.3051 36.5727C17.9635 36.7194 17.5961 36.7967 17.2243 36.7999C16.8525 36.8031 16.4838 36.7323 16.1397 36.5915C15.7956 36.4507 15.483 36.2428 15.2201 35.9799C14.9572 35.717 14.7493 35.4044 14.6085 35.0603C14.4677 34.7162 14.3969 34.3475 14.4001 33.9757C14.4033 33.6039 14.4806 33.2365 14.6273 32.8949C14.7741 32.5532 14.9874 32.2443 15.2548 31.986L21.6752 25.5656L15.2548 19.1452C14.7448 18.6171 14.4625 17.9098 14.4689 17.1757C14.4753 16.4415 14.7698 15.7392 15.2889 15.2201C15.8081 14.701 16.5103 14.4065 17.2445 14.4001C17.9786 14.3937 18.6859 14.6759 19.214 15.186L25.6344 21.6064L32.0548 15.186C32.5829 14.6759 33.2902 14.3937 34.0243 14.4001C34.7585 14.4065 35.4608 14.701 35.9799 15.2201C36.499 15.7392 36.7935 16.4415 36.7999 17.1757C36.8063 17.9098 36.524 18.6171 36.014 19.1452Z"
                      fill="#4B5563" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M11.3775 46.8856C15.5875 49.6986 20.5371 51.2 25.6003 51.2C32.3876 51.1924 38.8947 48.4928 43.694 43.6935C48.4934 38.8942 51.193 32.3872 51.2006 25.6C51.2006 20.5368 49.6992 15.5873 46.8862 11.3774C44.0732 7.16751 40.075 3.8863 35.3971 1.94869C30.7193 0.011092 25.5719 -0.495873 20.6059 0.491908C15.64 1.47969 11.0784 3.91785 7.49817 7.49807C3.9179 11.0783 1.47971 15.6398 0.491914 20.6057C-0.495879 25.5716 0.0110922 30.7189 1.94872 35.3967C3.88634 40.0745 7.1676 44.0726 11.3775 46.8856ZM14.9332 9.63579C18.0907 7.52607 21.8029 6.40001 25.6003 6.40001C30.691 6.40509 35.5717 8.42957 39.1713 12.0292C42.7709 15.6288 44.7955 20.5094 44.8005 25.6C44.8005 29.3974 43.6745 33.1095 41.5647 36.2669C39.455 39.4244 36.4563 41.8853 32.9479 43.3385C29.4395 44.7917 25.579 45.1719 21.8545 44.4311C18.1301 43.6902 14.7089 41.8616 12.0237 39.1764C9.3385 36.4913 7.50986 33.0702 6.76901 29.3457C6.02817 25.6213 6.4084 21.7608 7.86162 18.2525C9.31484 14.7441 11.7758 11.7455 14.9332 9.63579Z"
                      fill="#4B5563" />
                    <path
                      d="M58.5382 63.0624C59.1382 63.6626 59.952 63.9998 60.8006 64C61.4335 63.9999 62.052 63.8121 62.5781 63.4605C63.1043 63.1089 63.5143 62.6091 63.7565 62.0245C63.9986 61.4399 64.062 60.7965 63.9385 60.1759C63.8151 59.5552 63.5105 58.9851 63.0631 58.5376L50.2629 45.7376C49.6594 45.1547 48.8511 44.8322 48.012 44.8394C47.173 44.8467 46.3704 45.1833 45.7771 45.7766C45.1837 46.3699 44.8472 47.1725 44.8399 48.0115C44.8326 48.8506 45.1552 49.6589 45.7381 50.2624L58.5382 63.0624Z"
                      fill="#4B5563" />
                  </svg>
                  <h4 class="text-base text-gray-600 mb-0">No results found</h4>
                  <p class="text-sm text-gray-500">Change your keyword or filter</p>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:row="props">
          <tr>
            <td :class="props.tdClass">
              <span>
                {{ props.row.title }}
              </span>
            </td>
            <td :class="props.tdClass" class="cursor-pointer text-left trou w-[500px]">
              <div style="width: 100%; max-width: 400px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{ props.row.message }}
              </div>
            </td>
            <td :class="props.tdClass" class="text-gray-600">
              <span>{{ formatDate(props.row.valid_from) }} - {{ formatDate(props.row.valid_to) }}</span>
            </td>
            <td :class="props.tdClass" class="text-gray-600">
              <div v-if="props.row.is_active == true">
                <span class="bg-green-50 text-green-700 rounded-lg font-semibold text-xs px-2 py-2">Active</span>
              </div>
              <div v-if="props.row.is_active == false">
                <span class="bg-gray-100 text-gray-700 rounded-lg px-2 py-2 font-semibold text-xs">Inactive</span>
              </div>
            </td>
            <td :class="props.tdClass" class="text-gray-600">
              <div class="navbar-right relative">
                <button @click="toggleDropdown(props.rowIndex)" id="dropdownMenuIconHorizontalButton"
                  class="inline-flex items-center p-2 text-sm font-medium text-center text-gray-900" type="button">
                  <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                    viewBox="0 0 16 3">
                    <path
                      d="M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
                  </svg>
                </button>
                <div v-if="selectedIndex === props.rowIndex" @click="closeDropdown" tabindex="-1"
                  class="fixed top-0 inset-0 h-full w-full bg-black opacity-0 cursor-default"></div>
                <div v-if="selectedIndex === props.rowIndex"
                  class="absolute z-10 top-auto right-2 w-48 py-2 mt-2 rounded-lg border-gray-900 bg-white shadow-xl">
                  <ul class="px-2 mb-0 text-sm text-gray-500 dark:text-gray-200"
                    aria-labelledby="dropdownMenuIconHorizontalButton">
                    <li>
                      <router-link class="text-gray-500 w-full block list-none"
                        :to="{ path: `/settings/announcement/edit/${props.row.id}` }">
                        <div
                          class="flex w-full items-end justify-start px-3 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white text-gray-500 text-left">
                          <svg class="w-6 h-6 text-gray-500 dark:text-white" aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                            viewBox="0 0 24 24">
                            <path fill-rule="evenodd"
                              d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                              clip-rule="evenodd" />
                            <path fill-rule="evenodd"
                              d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                              clip-rule="evenodd" />
                          </svg>
                          <span class="ml-2">Edit</span>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </t-table>
      <div v-if="totalRows / perPage > 1" class="flex justify-between ml-1 px-4 items-center align-middle mt-3 bg-white">
        <div class="font-semibold">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
            class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
        </div>
        <div class="mt-2.5">
          <t-pagination
            :total-items="Number(totalRows)"
            :per-page="perPage"
            v-model="currentPage"
            class="rounded-lg"
            @update:modelValue="filterByPagination"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { AnnouncementCreatePath, AnnouncementEditPath } from "../../router/announcements";
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';

export default {
  name: "manage-announcement",
  components: {
    HeaderBreadcrumbs,
  },
  data() {
    return {
      AnnouncementCreatePath,
      AnnouncementEditPath,
      currentPage: 1,
      perPage: 15,
      query_search: '',
      selectedIndex: null,
      sortKey: 'valid_from', // Default sort field
      sortAsc: false, // Default sort direction
      discoundID: Number,
      isLoadingSearch: false,
      fields: [
        { key: "No", label: "No" },
        {
          key: "created",
          label: "Created",
          formatter: function(value) {
            return moment(value).format("DD-MM-YYYY");
          },
        },
        {
          key: "title",
          label: "Title",
        },
        {
          key: "publisher_name",
          label: "Publisher",
        },
        { key: "is_active", label: "Status" },
        { key: "action_edit", label: "Edit" },
      ],
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.announcement.isLoading,
      items: (state) => state.announcement.items,
      isError: (state) => state.announcement.isError,
      totalRows: (state) => state.announcement.totalRows,
    }),
    sortedItems() {
      if (!this.items || !this.items.length) return [];

      return [...this.items].sort((a, b) => {
        let aVal = a[this.sortKey];
        let bVal = b[this.sortKey];

        // Handle null values
        if (aVal === null && bVal === null) return 0;
        if (aVal === null) return this.sortAsc ? 1 : -1;
        if (bVal === null) return this.sortAsc ? -1 : 1;

        // Special handling for dates
        if (this.sortKey === 'valid_from' || this.sortKey === 'valid_to') {
          aVal = new Date(aVal).getTime();
          bVal = new Date(bVal).getTime();
        }

        // Boolean comparison for status
        if (this.sortKey === 'is_active') {
          return this.sortAsc ? (aVal === bVal ? 0 : aVal ? -1 : 1) : (aVal === bVal ? 0 : aVal ? 1 : -1);
        }

        // Standard string/number comparison
        if (this.sortAsc) {
          return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
        } else {
          return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
        }
      });
    }
  },
  mounted() {
    this.actionGetAnnouncements();
  },
  watch: {
    currentPage: function() {
      this.actionGetAnnouncements();
    },
  },
  methods: {
    ...mapActions("announcement", ["fetchAnnouncements", "searchAnnouncement"]),
    actionGetAnnouncements() {
      if (this.query_search == "") {
        let payload = {
          page: this.currentPage,
          limit: this.perPage,
        };
        this.fetchAnnouncements(payload);
      } else {
        this.asyncFind();
      }
    },
    sortBy(key) {
      // Toggle sort direction if same key is clicked again
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = false;
      }
    },
    toggleDropdown(index) {
      this.selectedIndex = this.selectedIndex === index ? null : index;
    },
    closeDropdown() {
      this.selectedIndex = null;
    },
    filterByPagination(page) {
      if (!page) return;
      this.currentPage = page;
      this.actionGetAnnouncements();
    },
    setQuerySearch(query) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.query_search = query;
      }, 1000);
    },
    formatDate(dateStr) {
      if (!dateStr) return 'N/A';

      try {
        const date = new Date(dateStr);

        if (isNaN(date.getTime())) {
          return 'Invalid date';
        }

        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day} ${month} ${year}, ${hours}:${minutes}`;
      } catch (error) {
        console.error('Error formatting date:', error);
        return 'Date error';
      }
    },
    asyncFind() {
      this.isLoadingSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        const query = this.query_search;
        if (!query) {
          this.actionGetAnnouncements();
          this.isLoadingSearch = false;
          return;
        }
        this.searchAnnouncement({
          q: query,
          page: this.currentPage,
          limit: this.perPage,
        })
          .then((response) => {
            this.items = response.data.data.rows;
            this.isLoadingSearch = false;
          })
          .catch(() => {
            this.isLoadingSearch = false;
          });
      }, 1000);
    },
    asyncClearFind() {
      this.query_search = "";
      this.actionGetAnnouncements();
      this.isLoadingSearch = false;
    },
  },
};
</script>
